import { LoadState } from "../../constants/enums";
import { IOpportunities, IOpportunityState } from "./opportunites.types";

export const defaultOpportunity: IOpportunities = {
	venue_uuid: null,
	venue_name: null,
	venue_address: null,
	capacity: null,
	status: "ACTIVE",
	company_outlet_uuid: "",
	company_outlet_name: "",
};

export const defaultOpportunityState: IOpportunityState = {
	list: {
		data: [],
		totalRecords: 0,
		loading: LoadState.InProgress,
		error: null,
	},
	opportunity: {
		data: defaultOpportunity,
		loading: LoadState.NotLoaded,
		error: null,
	},
};
